import { render, staticRenderFns } from "./sider-menu-shrink.vue?vue&type=template&id=2431ece9&scoped=true&"
import script from "./sider-menu-shrink.vue?vue&type=script&lang=js&"
export * from "./sider-menu-shrink.vue?vue&type=script&lang=js&"
import style0 from "./sider-menu-shrink.vue?vue&type=style&index=0&id=2431ece9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431ece9",
  null
  
)

export default component.exports